import React, { useState } from 'react'
import Box from '@mui/joy/Box'
import { ColorButton } from './ui/ColorButton'
import { TransparencySlider } from './TransparencySlider'
import { LayerControl } from './LayerControl'
import { DeleteButton } from './ui/DeleteButton'

export const ObjectGrid = ({
    onOpacityChange,
    onFillColorChange,
    onDelete,
    onLayerUp,
    onLayerDown,
    obj,
    children,
}) => {
    const OPACITY = obj.opacity * 100
    const [fillColor, setFillColor] = useState(obj.fill)

    const handleOpacityChange = (e) => {
        let value = e.target.value
        let newOpacity = Number(value) / 100
        onOpacityChange({ obj, value: newOpacity })
    }

    const handleFillColorChange = (color, event) => {
        console.log(color)
        let value = color.hex
        setFillColor(value)
        onFillColorChange({ obj, value })
    }

    return (
        <>
            <TransparencySlider
                onChange={handleOpacityChange}
                opacity={OPACITY}
            />
            <ColorButton
                onChange={handleFillColorChange}
                currentColor={fillColor}
            />
            <LayerControl
                onLayerUp={() => onLayerUp(obj)}
                onLayerDown={() => onLayerDown(obj)}
            />
            {children}
            <DeleteButton onClick={() => onDelete({ obj })} />
        </>
    )
}
